/* eslint-disable no-useless-escape */
import { notification } from 'antd'
import { Auth } from 'aws-amplify'
import moment from 'moment'

export default {
  downloadURI: (uri) => {
    const link = document.createElement('a')
    link.href = ''
    link.download = uri
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  },
  getCurrentSession: () => Auth.currentSession(),

  detectmob: () => window.innerWidth <= 800,

  validateEmail: (email) => {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  },

  tripEditorModules: {
    toolbar: [
      [{ size: [] }, { align: [] }],
      ['bold', 'italic', 'underline', 'blockquote'],
      [
        { list: 'ordered' },
        { list: 'bullet' },
        { indent: '-1' },
        { indent: '+1' },
      ],
      ['link', 'image'],
      ['clean'],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  },

  strip: (htmlString) => {
    let str = htmlString.replace(/<[^>]*>?/g, ' ')
    str = str.replace(/&nbsp;/g, ' ')
    str = str.replace(/\s{2,}/g, ' ')
    return str.trim()
  },

  truncate: (str, len = 40) => {
    if (str && str.length <= 3) {
      return str.substr(0, len)
    }
    if (str && str.length > len) {
      return `${str.substr(0, len - 3)}...`
    }
    return str
  },

  toCurrency: (num) => {
    if (Number.isNaN(num)) return null
    return parseFloat(num, 10).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    })
  },
  pluralize: (count, noun, suffix = 's') =>
    `${count} ${noun}${count !== 1 ? suffix : ''}`,

  dateFormat: (date) => {
    if (!date) return null
    const dateStr = date.toString()
    if (dateStr.length !== 8) return null
    const year = dateStr.substr(0, 4)
    const month = dateStr.substr(4, 2)
    const day = dateStr.substr(6, 2)
    const dateObj = new Date(year, month - 1, day)
    return moment(dateObj).format('MMMM D, YYYY')
  },
  showDate: (date) => {
    return moment(date).format('LLL')
  },

  tripRequestExpireOn: (date, onlyDate) => {
    if (!date) return null
    let expireOn = moment(date.toString()).add(72, 'hours')
    return onlyDate
      ? expireOn.format('ll')
      : expireOn.format('MMM D [at] HH:mm A')
  },
  getEndDate: (start, length) => {
    const startDate = moment(start.toString(), 'YYYYMMDD')
    return startDate.add(length, 'days')
  },
  duration: (start, end) => {
    if (!start || !end) return null

    const startStr = start.toString()
    if (startStr.length !== 8) return null
    const startDate = moment(
      new Date(
        startStr.substr(0, 4),
        startStr.substr(4, 2) - 1,
        startStr.substr(6, 2)
      )
    )

    const endStr = end.toString()
    if (endStr.length !== 8) return null
    const endDate = moment(
      new Date(
        endStr.substr(0, 4),
        endStr.substr(4, 2) - 1,
        endStr.substr(6, 2)
      )
    )

    return endDate.diff(startDate, 'days')
  },

  emailTruncateLable: (email) => {
    if (!email) return null

    const startChar = email.indexOf('+')
    const endChar = email.indexOf('@')
    if (startChar > -1 && endChar > -1) {
      return email.substr(0, startChar) + email.substr(endChar, email.length)
    }
    return email
  },
  getPermission: (currentUser, trip) => {
    return (
      currentUser?._id == trip?.ownerId ||
      trip?.permissions?.coHost ||
      currentUser?.isAdmin
    )
  },
  successToast: (msg) => {
    notification.success({ message: 'Success', description: msg })
    return true
  },
  errorToast: (msg) => {
    notification.error({ message: 'Error', description: msg })
    return false
  },
  getHostTripByFilter: (trips, filter) => {
    const active = []
    const canceled = []
    const completed = []
    trips &&
      trips?.map((trip) => {
        switch (trip?.status) {
          case 'created':
          case 'draft':
          case 'published':
            active.push(trip)
            break
          case 'completed':
            completed.push(trip)
            break
          case 'canceled':
          case 'cancelled':
            canceled.push(trip)
            break
        }
      })
    let finalTrips = []
    if (filter?.includes('active')) finalTrips = finalTrips.concat(active)
    if (filter?.includes('canceled')) finalTrips = finalTrips.concat(canceled)
    if (filter?.includes('completed')) finalTrips = finalTrips.concat(completed)
    return finalTrips
  },
  getTravelerTripsByFilter: (trips, filter) => {
    const current = []
    const inactive = []
    const upcoming = []
    trips &&
      trips?.map((trip) => {
        const startDate = trip?.startDate
        const endDate = trip?.endDate
        if (startDate) {
          const momStartDate = moment(startDate?.toString(), 'YYYYMMDD')
          const momEndDate = moment(endDate?.toString(), 'YYYYMMDD')
          // This will evaulaute either current or inactive else future
          if (moment().diff(momStartDate, 'days') >= 0) {
            if (moment().diff(momEndDate, 'days') <= 7) {
              current.push(trip)
            } else inactive.push(trip)
          } else {
            upcoming.push(trip)
          }
        } else {
          upcoming.push(trip)
        }
      })
    let finalTrips = []
    if (filter?.includes('current')) finalTrips = finalTrips.concat(current)
    if (filter?.includes('upcoming')) finalTrips = finalTrips.concat(upcoming)
    if (filter?.includes('inactive')) finalTrips = finalTrips.concat(inactive)
    return finalTrips
  },
}
